import { ReactNode } from 'react'
import MetaWalletContext from 'components/wallet/MetaWalletContext'
import { AptosWalletAdapterProvider } from '@aptos-labs/wallet-adapter-react'
import { MSafeWalletAdapter } from '@msafe/aptos-wallet-adapter'

export interface SuperWalletProviderProps {
  children: ReactNode
}

const envNet = process.env.REACT_APP_APTOS_NETWORK_SHORT || 'testnet'
const isMainnet = envNet === 'mainnet'

const msafeURL = isMainnet ? 'https://movement.m-safe.io' : 'https://movement-test.m-safe.io'

export const wallets = [] as any[]

// MSafe Wallet disabled until Movement support is complete
// export const wallets = [new MSafeWalletAdapter(msafeURL)]

function SuperWalletProvider({ children }: SuperWalletProviderProps) {
  return (
    <AptosWalletAdapterProvider
      autoConnect
      plugins={wallets}
      onError={(e: Error) => {
        console.log('Wallet Error:', e)
      }}>
      <MetaWalletContext>{children}</MetaWalletContext>
    </AptosWalletAdapterProvider>
  )
}

export default SuperWalletProvider
